import { bind } from '@react-rxjs/core'
import { startWith } from 'rxjs'

import { right } from '../../utils/result'
import { mapRight } from '../../utils/rx/operators'
import { searchParentOrProductBySkusQuery } from '../search/parent-or-product-by-skus-query'

// NOTE: use varargs for skus for compatibility with `state` observable factory's caching
const productsBySkus$ = (...skus: string[]) =>
  searchParentOrProductBySkusQuery({ skus }).pipe(
    mapRight((value) => right({ products: value.data })),
    startWith(right({ products: [] })),
  )

export const [useProductsBySkus, latestProductsBySkus$] = bind(productsBySkus$)
